export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7f8f91e072429aed4674a17d5045287a11d48e3179&name=getUserInfoServerAction!'